"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var Pre = function Pre(props) {
  var className = props.className,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "use"]);
  return _react.default.createElement("pre", (0, _extends2.default)({}, rest, {
    className: (0, _classNames.default)(className, {
      'private-pre--code': use === 'code'
    })
  }));
};

Pre.propTypes = {
  use: _react.PropTypes.oneOf(['default', 'code'])
};
Pre.defaultProps = {
  use: 'default'
};
Pre.displayName = 'Pre';
var _default = Pre;
exports.default = _default;
module.exports = exports.default;